import React, { FC } from "react";
import { JobPostCompositeStatus } from "@utils/db/JobPost/getCompositeStatus";

interface Props {
  compositeStatus: JobPostCompositeStatus;
}

export const JobPostCompositeStatusValue: FC<Props> = ({ compositeStatus }) => {
  switch (compositeStatus) {
    case JobPostCompositeStatus.DRAFT:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-orange-100 text-orange-600">
          draft
        </span>
      );
    case JobPostCompositeStatus.PENDING_APPROVAL:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-blue-100 text-blue-600">
          pending review
        </span>
      );
    case JobPostCompositeStatus.APPROVED:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-blue-100 text-blue-600">
          approved
        </span>
      );
    case JobPostCompositeStatus.PUBLISHED:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-green-100 text-green-600">
          published
        </span>
      );
    case JobPostCompositeStatus.STOPPED:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-red-100 text-red-600">
          stopped
        </span>
      );
    case JobPostCompositeStatus.EXPIRED:
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded font-medium bg-red-100 text-red-600">
          expired
        </span>
      );
  }
};
